import axios from 'axios';
import { DISTRIBUTION_TYPE_EQUALLY, DISTRIBUTION_TYPE_PARTS, DISTRIBUTION_TYPE_VALUE } from './panels/Items/components/DistributionTypeTabsComponent';

class HttpClient {
  #host = '';
  #token = null;
  #lang = 'ru';
  #initUserData = {};

  constructor(host) {
    this.#host = host;
  }

  getToken() {
    if (this.#token) {
      return 'Bearer ' + this.#token;
    }

    return null;
  }

  setToken(token) {
    this.#token = token;
  }

  getLang() {
    return this.#lang;
  }

  setLang(lang) {
    this.#lang = lang;
  }

  async initUserVk(data = {}) {
    this.#initUserData = data;
    return this.#post(this.#host + '/vk-mini-app', data);
  }

  async initUserTelegram(data = {}) {
    this.#initUserData = data;
    return this.#post(this.#host + '/telegram-bot-app', data);
  }

  async refreshToken() {
    return this.#post(this.#host + '/auth/refresh');
  }

  async getEvents(offset, q, archive = false) {
    return this.#get(this.#host + '/v3/events', {
      offset: offset,
      q: q,
      archive: archive ? 1 : 0,
    });
  }

  async getEventV3(id) {
    return this.#get(this.#host + '/v3/events/' + id);
  }

  async getEventV4(id) {
    return this.#get(this.#host + '/v4/events/' + id);
  }

  async getEventItems(eventId, offset) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/items', {
      offset: offset,
    });
  }

  async generateEventImage(eventId) {
    return this.#post(this.#host + '/v3/events/' + eventId + '/generate_image');
  }

  async getPayment(eventId, paymentId) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/payments/' + paymentId);
  }

  async getRepayment(eventId, repaymentId) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/repayments/' + repaymentId);
  }

  async addEventV4(name, image, generateImage, touchId) {
    const formData = new FormData();
    formData.append('name', name);
    if (image) {
      formData.append('image', image);
    } else if (generateImage) {
      formData.append('generate_image', 1);
    }

    return this.#post(this.#host + '/v4/events?tId=' + touchId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async updateEventV3(eventId, name, status, imageId) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('status', status);
    if (imageId !== undefined) {
      formData.append('image', imageId);
    } else {
      formData.append('clear_image', 1);
    }

    return this.#post(this.#host + '/v3/events/' + eventId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async addPaymentV4(eventId, name, comment, amount, date, users, creator, type, images, addJoinedMembers, receiptId) {
    const formData = new FormData()
    formData.append('name', name);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    formData.append('comment', comment);
    formData.append('creator', creator);
    formData.append('distribution_type', type);

    if (type === DISTRIBUTION_TYPE_EQUALLY) {
      if (users) {
        users.forEach((userId) => {
          formData.append('users[]', userId);
        });
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    } else if (type === DISTRIBUTION_TYPE_VALUE) {
      for (let userId in users) {
        formData.append('values[' + userId + ']', users[userId]);
      }
    } else if (type === DISTRIBUTION_TYPE_PARTS) {
      for (let userId in users) {
        formData.append('parts[' + userId + ']', users[userId]);
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    }

    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    if (receiptId) {
      formData.append('receipt_id', type);
    }

    return this.#post(this.#host + '/v4/events/' + eventId + '/payments', formData, {'Content-Type': 'multipart/form-data'});
  }

  async uploadItemImageV3(eventId, img) {
    const formData = new FormData();
    formData.append('image', img);

    return this.#post(this.#host + '/v3/events/' + eventId + '/items/upload', formData, {'Content-Type': 'multipart/form-data'});
  }

  async uploadEventImageV3(img) {
    const formData = new FormData();
    formData.append('image', img);

    return this.#post(this.#host + '/v3/events/upload', formData, {'Content-Type': 'multipart/form-data'});
  }

  async addEventItemsManyV4(eventId, items, date, creatorId, addJoinedMembers, receiptId) {
    const formData = new FormData();

    formData.append('date', new Date(date).toISOString());
    formData.append('creator', creatorId);
    formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    if (receiptId) {
      formData.append('receipt_id', receiptId);
    }

    items.forEach((item, number) => {
      formData.append('items[' + number + '][name]', item.name);
      formData.append('items[' + number + '][comment]', item.comment);
      formData.append('items[' + number + '][amount]', item.amount);
      item.users.forEach((user) => {
        formData.append('items[' + number + '][users][]', user.id || user.value || user);
      });
    });

    return this.#post(this.#host + '/v4/events/' + eventId + '/payments/many', formData, {'Content-Type': 'multipart/form-data'});
  }

  async updatePaymentV4(eventId, itemId, name, comment, price, date, users, creator, type, images, addJoinedMembers, updateToken) {
    const formData = new FormData()
    formData.append('name', name);
    formData.append('comment', comment);
    formData.append('amount', price);
    formData.append('date', new Date(date).toISOString());
    formData.append('creator', creator);
    formData.append('distribution_type', type);
    formData.append('update_token', updateToken);

    if (type === DISTRIBUTION_TYPE_EQUALLY) {
      if (users) {
        users.forEach((userId) => {
          formData.append('users[]', userId);
        });
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    } else if (type === DISTRIBUTION_TYPE_VALUE) {
      for (let userId in users) {
        formData.append('values[' + userId + ']', users[userId]);
      }
    } else if (type === DISTRIBUTION_TYPE_PARTS) {
      for (let userId in users) {
        formData.append('parts[' + userId + ']', users[userId]);
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    }

    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v4/events/' + eventId + '/payments/' + itemId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async deletePaymentV1(eventId, itemId) {
    return this.#delete(this.#host + '/events/' + eventId + '/payments/' + itemId);
  }

  async createInvite(eventId) {
    return this.#post(this.#host + '/events/' + eventId + '/invite');
  }

  async invite(invite) {
    return this.#get(this.#host + '/join/' + invite);
  }

  async leaveEvent(eventId) {
    return this.#post(this.#host + '/events/' + eventId + '/leave');
  }

  async scanReceipt(eventId, file) {
    const formData = new FormData();
    formData.append('data', file);

    return this.#post(this.#host + '/v2/events/' + eventId + '/receipt', formData, {'Content-Type': 'multipart/form-data'});
  }

  async getReceiptInfo(eventId, receiptId) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/receipt/' + receiptId);
  }

  async getReceipts(eventId, offset) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/receipt', {
      offset: offset,
    });
  }

  async scanQr(eventId, codeData) {
    return this.#post(this.#host + '/v3/events/' + eventId + '/scan_qr', {
      data: codeData.code_data,
    });
  }

  async log(data) {
    return this.#post(this.#host + '/log', data);
  }

  async eventDeleteUser(eventId, userId) {
    return this.#delete(this.#host + '/events/' + eventId + '/users/' + userId);
  }

  async createRepaymentV3(eventId, from, to, amount, date, comment, images) {
    const formData = new FormData()
    formData.append('from', from);
    formData.append('to', to);
    formData.append('comment', comment);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v3/events/' + eventId + '/repayments', formData, {'Content-Type': 'multipart/form-data'});
  }

  async createRepaymentV4(eventId, from, to, amount, date, comment, images) {
    const formData = new FormData()
    formData.append('from', from);
    formData.append('to', to);
    formData.append('comment', comment);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v4/events/' + eventId + '/repayments', formData, {'Content-Type': 'multipart/form-data'});
  }

  async updateRepaymentV3(eventId, itemId, from, to, amount, date, comment, images, updateToken) {
    let formData = new FormData()
    formData.append('from', from);
    formData.append('to', to);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    formData.append('comment', comment);
    formData.append('update_token', updateToken);
    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v3/events/' + eventId + '/repayments/' + itemId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async deleteRepaymentV1(eventId, itemId) {
    return this.#delete(this.#host + '/events/' + eventId + '/repayments/' + itemId);
  }

  async profile() {
    return this.#get(this.#host + '/profile');
  }

  async updateProfile(data) {
    return this.#post(this.#host + '/v2/profile', data);
  }

  async passedOnBoarding() {
    return this.#post(this.#host + '/profile/passed_on_boarding');
  }

  async sendInviteMessage(eventId) {
    return this.#post(this.#host + '/events/' + eventId + '/send_invite_tg');
  }

  async #post(url, data, headers = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, {
          cache: 'no-cache',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.getToken(),
            'Lang': this.getLang(),
            ...headers,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            this.refreshToken()
              .then((response) => {
                this.setToken(response.data.token);

                axios.post(url, data, {
                    cache: 'no-cache',
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': this.getToken(),
                      'Lang': this.getLang(),
                      ...headers,
                    },
                  })
                  .then((response) => {
                    resolve(response);
                  })
                  .catch((error) => reject(error));
              })
              .catch((errorToken) => {
                reject(error);
              });
          } else {
            reject(error);
          }
        });
    });
  }

  async #get(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
          cache: 'no-cache',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.getToken(),
            'Lang': this.getLang(),
          },
          params: params,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            this.refreshToken()
              .then((response) => {
                this.setToken(response.data.token);

                axios.get(url, {
                    cache: 'no-cache',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': this.getToken(),
                      'Lang': this.getLang(),
                    },
                    params: params,
                  })
                  .then((response) => {
                    resolve(response);
                  })
                  .catch((error) => reject(error));
              })
              .catch((errorToken) => {
                reject(error);
              });
          } else {
            reject(error);
          }
        });
    });
  }

  async #delete(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.delete(url, {
          cache: 'no-cache',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.getToken(),
            'Lang': this.getLang(),
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            this.refreshToken()
              .then((response) => {
                this.setToken(response.data.token);

                axios.delete(url, {
                    cache: 'no-cache',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': this.getToken(),
                      'Lang': this.getLang(),
                    },
                  })
                  .then((response) => {
                    resolve(response);
                  })
                  .catch((error) => reject(error));
              })
              .catch((errorToken) => {
                reject(error);
              });
          } else {
            reject(error);
          }
        });
    });
  }
}

export default HttpClient;
